<template>
  <div>
    <v-subheader class="text-body-2 pa-0 " style="height: auto;" :class="[subheaderColor]">
      {{ $i18n.t(translationPath) }}
    </v-subheader>
    <v-otp-input
      v-if="dataTypeName === 'otp'"
      v-bind="$attrs"
      v-on="$listeners"
      @update:hasError="updateError"
      @focus="isFocused = true"
      @blur="isFocused = false"
    ></v-otp-input>
    <data-input
      v-else
      @focus="isFocused = true"
      @blur="isFocused = false"
      @update:hasError="updateError"
      v-on="$listeners"
      dense
      height="44px"
      v-bind="$attrs"
      outlined
      :data-type="{ name: dataTypeName }"
    >
    </data-input>
  </div>
</template>

<script>
import DataInput from '@/components/DataInput';

export default {
  name: 'AuthenticationInput',
  components: {
    DataInput,
  },
  props: {
    translationPath: {
      type: String,
      required: true,
    },
    dataTypeName: {
      type: String,
      default: 'text',
    },
  },
  data: () => ({
    isFocused: false,
    hasError: false,
  }),
  computed: {
    subheaderColor() {
      if (this.isFocused) {
        return 'link--text';
      }
      return this.hasError ? 'error--text' : 'italic--text';
    },
  },
  methods: {
    updateError(data) {
      this.hasError = data;
      this.$emit('update:hasError', data);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-text-field__details {
  padding: 0 !important;
}
</style>
